<div *ngFor="let table of arrTable" class="elementinnerholder">
    <div class="container containerwo">
        <div *ngIf="table.title != ''" class="title">
            {{ table.title }}
        </div>

        <div class="row">
            <div *ngFor="let table1 of arrTable1" class="cimage col-xs-6 col-md-3 col-sm-6">
                <a class="fimage" data-fancybox="images" href="/.ci.{{ table1.imagefileid }}.0.0.png" [attr.data-caption]="table1.filetitle">
                    <img class="largeimage img-responsive" src="/.ci.{{ table1.imagefileid }}.400.400.0.0.0.0.400.400.c.png" alt="{{table1.filetitle}}" title="{{table1.filetitle}}" />
                </a>
            </div>
        </div>

        <div *ngIf="table.buttontitle != ''" class="button">
            <a class="whitebutton" href="{{ table.urlwebpageid != '' ? table.urlwebpageid : table.url }}" target="{{ table.urlopentype == 2 ? '_blank' : '' }}">
                {{ table.buttontitle }}
            </a>
        </div>
    </div>
</div>

